export default "__VITE_ASSET__6f3f1c9e__"